export default function initEmployerAuth() {
    const inputsContainer = document.getElementById("tth-code-inputs");

    if (!inputsContainer) {
        return;
    }

    // Event Delegation for Input
    inputsContainer.addEventListener("input", function (e) {
        const target = e.target;
        if (target.tagName !== "INPUT") return;

        const val = target.value;

        // Allow alphanumeric only
        if (!/^[a-zA-Z0-9]*$/.test(val)) {
            target.value = "";
            return;
        }

        // Force Uppercase
        if (val !== val.toUpperCase()) {
            target.value = val.toUpperCase();
        }

        if (target.value !== "") {
            const next = target.nextElementSibling;

            if (next) {
                next.focus();
            }
        }
    });

    // Event Delegation for Navigation
    inputsContainer.addEventListener("keyup", function (e) {
        const target = e.target;
        if (target.tagName !== "INPUT") return;

        const key = e.key.toLowerCase();

        if (key === "backspace" || key === "delete") {
            target.value = "";
            const prev = target.previousElementSibling;
            if (prev) {
                prev.focus();
            }
            return;
        }

        if (key === "arrowleft") {
            const prev = target.previousElementSibling;
            if (prev) prev.focus();
        }
        if (key === "arrowright") {
            const next = target.nextElementSibling;
            if (next) next.focus();
        }
    });

    // Paste Logic
    inputsContainer.addEventListener('paste', function (e) {
        e.preventDefault();
        const target = e.target;
        if (target.tagName !== "INPUT") return;

        const clipboardData = (e.clipboardData || window.clipboardData);
        const text = clipboardData.getData('text').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

        if (text && text.length > 0) {
            const inputs = inputsContainer.querySelectorAll('input');
            // Find index of target
            let currentIndex = Array.from(inputs).indexOf(target);

            for (let i = 0; i < text.length && currentIndex < inputs.length; i++) {
                inputs[currentIndex].value = text[i];
                currentIndex++;
            }

            if (currentIndex < inputs.length) {
                inputs[currentIndex].focus();
            } else {
                inputs[inputs.length - 1].focus();
            }
        }
    });

    // Select text on focus
    inputsContainer.addEventListener('focusin', function (e) {
        if (e.target.tagName === "INPUT") {
            e.target.select();
        }
    });
}

// Logic to replace container on success
document.addEventListener("DOMContentLoaded", function () {
    const successWrapper = document.querySelector('.tth-counsellors-list-wrapper');
    if (successWrapper) {
        const replaceId = successWrapper.dataset.replaceId;
        if (replaceId) {
            // Try matching ID exactly or with/without hash just in case
            const cleanId = replaceId.replace(/^#/, '');
            let targetContainer = document.getElementById(cleanId);

            if (targetContainer) {
                // Clear all existing content (including that paragraph)
                targetContainer.innerHTML = '';

                // Move wrapper into container
                targetContainer.appendChild(successWrapper);

                // Force visibility styles on both wrapper and container
                targetContainer.style.visibility = 'visible';
                targetContainer.style.opacity = '1';
                targetContainer.style.display = 'block';

                successWrapper.style.visibility = 'visible';
                successWrapper.style.opacity = '1';
                successWrapper.style.display = 'block';
            }
        }
    }

    // Modal Logic
    const body = document.body;
    const modal = document.getElementById('tth-counsellor-modal');

    if (modal) {
        const modalTitle = modal.querySelector('.tth-modal-title');
        const modalSubtitle = modal.querySelector('.tth-modal-subtitle');
        const modalDescription = modal.querySelector('.tth-modal-description');
        const modalImage = modal.querySelector('.tth-modal-image');
        const modalBookBtn = modal.querySelector('.tth-modal-book-btn');
        let lastFocusedElement;

        function openModal(trigger) {
            lastFocusedElement = trigger;

            // Find data container
            const card = trigger.closest('.counsellors');
            const dataContainer = card.querySelector('.tth-popup-data');

            if (!dataContainer) return;

            // Populate Data
            const imgUrl = dataContainer.querySelector('.data-image').textContent;
            const title = dataContainer.querySelector('.data-title').innerHTML;
            const subtitle = dataContainer.querySelector('.data-subtitle').innerHTML;
            const content = dataContainer.querySelector('.data-content').innerHTML;
            const bookUrl = dataContainer.querySelector('.data-booking-url').textContent;

            modalTitle.innerHTML = title;
            modalSubtitle.innerHTML = subtitle;
            modalDescription.innerHTML = content;
            modalBookBtn.href = bookUrl;

            if (imgUrl) {
                modalImage.style.backgroundImage = `url('${imgUrl}')`;
            } else {
                modalImage.style.backgroundImage = 'none';
            }

            // Show Modal
            modal.setAttribute('aria-hidden', 'false');
            modal.classList.add('is-open');
            body.classList.add('tth-modal-open');

            // Trap Focus
            const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusable.length) focusable[0].focus();
        }

        function closeModal() {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            body.classList.remove('tth-modal-open');

            if (lastFocusedElement) lastFocusedElement.focus();
        }

        // Event Delegation for dynamic list
        document.addEventListener('click', function (e) {
            if (e.target.closest('[data-trigger-popup]')) {
                e.preventDefault();
                openModal(e.target.closest('[data-trigger-popup]'));
            }
            if (e.target.closest('[data-close-modal]')) {
                closeModal();
            }
        });

        // Keyboard Accessibility
        document.addEventListener('keydown', function (e) {
            if (!modal.classList.contains('is-open')) return;

            if (e.key === 'Escape') {
                closeModal();
            }

            if (e.key === 'Tab') {
                const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                const first = focusable[0];
                const last = focusable[focusable.length - 1];

                if (e.shiftKey) {
                    if (document.activeElement === first) {
                        e.preventDefault();
                        last.focus();
                    }
                } else {
                    if (document.activeElement === last) {
                        e.preventDefault();
                        first.focus();
                    }
                }
            }
        });
    }
});
